
export const NAME_REDUCER = 'shop';

export const PREFIX_ACTIONS = 'shop_feature_';

export const PATH_LOADING = {
  getShopInfo: `loading.${NAME_REDUCER}.getShopInfo`,
  getStaffList: `loading.${NAME_REDUCER}.getStaffList`,
  getCategories: `loading.${NAME_REDUCER}.getCategories`,
};

export const SHOP_ID_BLACKLIST = [
  '4496a48a-dc44-4160-9c63-fb07696a45c7'
];
